<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off">
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <div class="input_radio">
        <div class="text_info">
          <app-label [control]="gebaeudeHochwasserzone" for="gebaeudeHochwasserzone">Das Gebäude liegt in Hochwasserzone mit hoher Gefährdung (HQ30):</app-label>
          <div class="info">
            <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('GEBAEUDEHOCHWASSERZONEINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
          </div>
        </div>
        <mat-radio-group id="gebaeudeHochwasserzone" formControlName="gebaeudeHochwasserzone">
          <mat-radio-button value="ja">Ja</mat-radio-button>
          <mat-radio-button value="nein">Nein</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="gebaeudeHochwasserzone.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
      </div>
    </div>
  </div>
</form>
